import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities'
import { createContext } from 'react'

export interface DragContextProps {
  setActivatorNodeRef?: (element: HTMLElement | null) => void
  listeners?: SyntheticListenerMap
}

export const DragContext = createContext<DragContextProps>({})
